/** @format */
import React, { useEffect, useMemo, useState } from 'react';

// datamodel for the data from backend
export interface BotSettings {
  token: string;
  streamUrl: string;
  userAccessLevel: string;
  customCssUrl: string;
  customJsUrl: string;
  cidCookieName: string;
  uidCookieName: string;
  showTitleBar: string;
  webChatTile: string;
  favIcon: string;
}

// retrieves the settings from backend
export function getSettingsFromBackend(): Promise<BotSettings> {
  return new Promise((resolve, reject) => {
    fetch('/api/Settings')
      .then(async (response) => {
        let responseText = await getTextFromStream(response.body);
        return responseText;
      })
      .then((responseText) => {
        let botSettings: BotSettings = JSON.parse(responseText);
        resolve(botSettings);
      })
      .catch((error) => reject(error));
  });
}

export function getSettingsFromBackendWithConversationId(
  conversationId: string
): Promise<BotSettings> {
  return new Promise((resolve, reject) => {
    fetch('/api/Settings', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: '"' + conversationId + '"',
    })
      .then(async (response) => {
        let responseText = await getTextFromStream(response.body);
        //console.log(responseText);
        return responseText;
      })
      .then((responseText) => {
        let botSettings: BotSettings = JSON.parse(responseText);
        resolve(botSettings);
      })
      .catch((error) => reject(error));
  });
}

// helper function to properly read the contents from the fetched data
export const getTextFromStream = async (
  readableStream: ReadableStream<Uint8Array> | null
) => {
  if (readableStream != null) {
    let reader = readableStream.getReader();
    let utf8Decoder = new TextDecoder();
    let nextChunk;

    let resultStr = '';

    while (!(nextChunk = await reader.read()).done) {
      let partialData = nextChunk.value;
      resultStr += utf8Decoder.decode(partialData);
    }

    return resultStr;
  } else {
    return 'bla';
  }
};
